<template>
  <div class="bg-white max-w-lg my-4">
    <a-list bordered :data-source="missingFundReports">
      <h3 slot="header" class="text-xl font-semibold">MISSING REPORTS</h3>
      <a-list-item slot="renderItem" slot-scope="item">
        <div class="w-full">
          <span
            @click="addReport(item.year, item.month)"
            class="cursor-pointer text-terracotta hover:underline"
          >
            {{ item.year }} - {{ item.month }}
          </span>
        </div>
      </a-list-item>
    </a-list>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  props: {
    fundId: {
      type: String,
      required: true,
    },
  },
  apollo: {
    missingFundReports: {
      query: gql`
        query GetMissingFundReports($fundId: Uuid!) {
          missingFundReports(fundId: $fundId) {
            year
            month
          }
        }
      `,
      variables() {
        return {
          fundId: this.fundId,
        }
      },
    },
  },
  data() {
    return {
      missingFundReports: [],
    }
  },
  methods: {
    addReport(year, month) {
      this.$emit('addReport', { fundId: this.fundId, year, month })
    },
    reloadReports() {
      this.$apollo.queries.missingFundReports.refetch()
    },
  },
}
</script>

<style></style>
